/*
 * Special event for image load events
 * Needed because some browsers does not trigger the event on cached images.

 * MIT License
 * Paul Irish     | @paul_irish | www.paulirish.com
 * Andree Hansson | @peolanha   | www.andreehansson.se
 * 2010.
 *
 * Usage:
 * $(images).bind('load', function (e) {
 *   // Do stuff on load
 * });
 * 
 * Note that you can bind the 'error' event on data uri images, this will trigger when
 * data uri images isn't supported.
 * 
 * Tested in:
 * FF 3+
 * IE 6-8
 * Chromium 5-6
 * Opera 9-10

(function ($) {
	$.event.special.load = {
		add: function (hollaback) {
			if ( this.nodeType === 1 && this.tagName.toLowerCase() === 'img' && this.src !== '' ) {
				// Image is already complete, fire the hollaback (fixes browser issues were cached
				// images isn't triggering the load event)
				if ( this.complete || this.readyState === 4 ) {
					hollaback.handler.apply(this);
				}

				// Check if data URI images is supported, fire 'error' event if not
				else if ( this.readyState === 'uninitialized' && this.src.indexOf('data:') === 0 ) {
					$(this).trigger('error');
				}
				
				else {
					$(this).bind('load', hollaback.handler);
				}
			}
		}
	};
}(jQuery));
 */




// usage: log('inside coolFunc', this, arguments);
// paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
window.log = function(){
  log.history = log.history || [];   // store logs to an array for reference
  log.history.push(arguments);
  if(this.console) {
      arguments.callee = arguments.callee.caller;
      console.log( Array.prototype.slice.call(arguments) );
  }
};
// make it safe to use console.log always
(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();)b[a]=b[a]||c})(window.console=window.console||{});


var Tranceformations = {
	
	trackEvent : function(c, a, l, v) {
		try {
			var _gaq = _gaq || [];
			log('_trackEvent', c, a, l, v);
			_gaq.push(['_trackEvent', c, a, l, v]);
		} catch (e) {}
	},
	
	initMobileSidebar : function () {
		$('#sidebar h3').live('click', function () {
			// TODO: deal with floats
			// see http://stackoverflow.com/questions/2817944/jquery-slidedown-css-floats
			if ( $(window).width() < 1048 ) {
				$('#sidebar .content').toggle(300);
			}
		});
	},
	
	initTOC : function () {
		$('.toc.products a').hover(
			function () {
				var h = $('span', this).outerHeight(false);
				log('hover', h);
				$('span', this).stop(true, false).css('bottom', h * -1).show().animate({bottom: 0}, 200);
			},
			
			function () {
				$('span', this).hide();				
			}
		);
	},
		
	initCollectionFilter : function () {
		var filters = $('#option_filter .facet select'),
		    products = $('.toc li'),
		    sel = []
		    msg = $('#option_message');
		
		if (filters.length < 1 || products.length < 1) {
			return false;
		}

		filters.bind('change', function () {
			sel = $.map(filters, function(el, idx) {
				if ($(el).val()) {
					return $(el).val();
				}
			}).join('.').trim();
			
			if (sel.length > 1) {		
				sel = '.' + sel;
				products.hide().filter(sel).show();
				
				if (products.filter(':visible').length < 1) {
				  msg.text('Nothing matches your selection.').show();
				} else {
				  msg.hide();
				}
				
			} else {
				products.show();
			}
			
			Tranceformations.trackEvent('collection', 'filter', $(this).val());

		});
		
	},
	
	initSharing : function () {
		$('#sharelink').bind('click', function () {
			var c = $(this).data('category'),
			    h = $(this).data('handle');
			$(this).hide();
			$('#shareui').show();

			Tranceformations.trackEvent(c, 'reveal-share-ui', h);
			
			return false;
		});
	},
	
	initVariantSelector: function(options) {
		var product = options.product || null,
		    sel = $('#variant_select');
		
		if ( !product ) {
			return;
		}

		log('initVariantSelector', product);
		
		Tranceformations.updateVariantForPurchase(product.variants[0]);	
		
		sel.bind('change', function(evt) {
			var variant_id = parseInt($(this).val(), 10),
			    variant    = null;

			if (variant_id) {
				jQuery.each( product.variants, function(idx, val) {
					if (variant_id === val.id) {
						variant = val;
					}				
				});
			}
			
			log('variant is', variant);
			Tranceformations.updateVariantForPurchase(variant);		
		});
		

	},
	
	updateVariantForPurchase: function(variant) {
		var price = '';
		log('updating for purchase info');
    if (variant && variant.available == true) {
      $('#purchase').removeClass('disabled').removeAttr('disabled').text('Purchase');
                
      if (variant.compare_at_price) {
        price = '<del>' + Tranceformations.formatMoney(variant.compare_at_price, "") + '</del> ';
      }
      
      price += Tranceformations.formatMoney(variant.price, "");
    } else {
      // variant doesn't exist
      $('#purchase').addClass('disabled').attr('disabled', 'disabled').text('Not available');
      price = '';
    }

    $('#price-field').html(price);
	},

	
	initProductGallery : function () {
		var g = $('#product_gallery'),
		    v = null,
		    t = null,
		    l = null,
		    h = null;
		
		if (g.length < 1) {
			return false;
		}

		v = $('.photo', g);
		l = $('.ajaxloader', g);
		t = $('.thumbs a', g);
		h = $('#content').data('product-handle');

		if (v.length < 1 || t.length < 1) {
			log('no thumbs OR viewer');
			return false;
		}

				
		t.bind('click', function () {
			$('.viewer', g).show(); // in case it's hidden, as in iOS
			v.attr('src', $(this).attr('href'));		

			Tranceformations.trackEvent('product', 'gallery-click', h);
			
			return false;
		});
	},
	
	initShopping : function () {
		log('initShopping');
		
		var f = $('#add_to_cart_form'),
		    status = null;
		
		if (f.length < 1) {
			return;
		}
		
		log('binding');
		$('<div id="cartadded">+1</div>').insertBefore('#cartinfo');
		status = $('#cartadded');
					
		f.bind('submit', function (evt) {
			evt.preventDefault();
			var data = { quantity: 1, id: $('#variant_select').val() };
			log('data', data);
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				data: data,
				dataType: 'json',
				success: function (d, s, xhr) {
					if (s !== 'success') {
						// do a normal post and let that display the error
						f.unbind('submit').submit();
					}
					Tranceformations.updateCartStatusBar();
					status.stop(true, true).fadeIn(100).delay(2000).fadeOut(700);

					$('#add_to_cart_message').css('visibility', 'visible');


					log('success', d, s, xhr);
				}
			
			});
			return false;
		})
		
		// 			
		
		
	},

	updateCartStatusBar: function() {
		$.ajax({
			type: 'GET',
			url: '/cart.js',
			dataType: 'json',
			success: function (d, s, xhr) {
				if (s === 'success') {
					var msg = '<strong>' + d.item_count +
					    (parseInt(d.item_count, 10) === 1 ? ' item' : ' items') +
					    '</strong><br>Total: ' + Tranceformations.formatMoney(d.total_price, "");
					$('#cartinfo').html(msg);
				}
			}
		});
	},
	
	initLocationMap : function() {
		var location = $('#location_map').data('location'),
		    lat_lng = null,
		    map = null,
		    marker = null,
		    infowindow = null;
		
		if (!location || !google) {
			return false;
		}
		
		if (location === 'nanaimo') {
			lat_lng = new google.maps.LatLng(49.207974, -124.014893);
		} else if (location === 'courtenay') {
			lat_lng = new google.maps.LatLng(49.690128, -125.001498);
		}
		
		if (!lat_lng) {
			log('unknown location', location);
			return false;
		}

    var map = new google.maps.Map(document.getElementById("location_map"), {
      zoom: 13,
      center: lat_lng,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    });

		infowindow = new google.maps.InfoWindow({
			content: $('#sidebar .address p:first').html()
		});

		marker = new google.maps.Marker({
		  position: lat_lng,
		  map: map,
		  title: 'Tranceformations'
		});

		google.maps.event.addListener(marker, 'click', function() {
		  infowindow.open(map, marker);
		});
	},
	
	initTracking: function () {
		$('a[rel=external]').live('click', function () {
			try {
				log('tracking', '_trackPageview', '/_outbound/' + encodeURIComponent($(this).attr('href')));
				var _gaq = _gaq || [];
				_gaq.push(['_trackPageview', '/_outbound/' + encodeURIComponent($(this).attr('href'))]);
			} catch (e) {}
			return true;
		});
		
		$('#email_signup').live('submit', function () {
			Tranceformations.trackEvent('email', 'subscribe', $('#email').val());
			return true;
		});
		
		try {
			if (typeof(FB) !== 'undefined') {
				FB.Event.subscribe('edge.create', function(href, widget) {
					Tranceformations.trackEvent('social', 'facebook-like', href);
				});

				FB.Event.subscribe('edge.remove', function(href, widget) {
					Tranceformations.trackEvent('social', 'facebook-unlike', href);
				});
			}
		} catch (e) {
			log('FB Event sub', e);
		}
		
		
		try {
			if (typeof(twttr) !== 'undefined') {
				twttr.events.bind('tweet', function(evt) {
					Tranceformations.trackEvent('social', 'twitter-tweet', document.URL);
				});
			
				twttr.events.bind('click', function(evt) {
					Tranceformations.trackEvent('social', 'twitter-click', document.URL);
				});
			}
		} catch (e) {
			log('Twitter error', e);
		}
		
		
	},
	
	// from http://cdn.shopify.com/s/shopify/option_selection.js
	formatMoney: function(cents, format) {
		var money_format = "$ {{amount}}";
	  if (typeof cents == 'string') cents = cents.replace('.','');
	  var value = '';
	  var patt = /\{\{\s*(\w+)\s*\}\}/;
	  var formatString = (format || money_format);
	  switch(formatString.match(patt)[1]) {
	  case 'amount':
	    value = Tranceformations.floatToString(cents/100.0, 2);
	    break;
	  case 'amount_no_decimals':
	    value = Tranceformations.floatToString(cents/100.0, 0);
	    break;
		case 'amount_with_comma_separator':
			value = Tranceformations.floatToString(cents/100.0, 2).replace(/\./, ',');
			break;
	  }    
	  return formatString.replace(patt, value);
	},

	// from http://cdn.shopify.com/s/shopify/option_selection.js
	floatToString: function(numeric, decimals) {  
	  var amount = numeric.toFixed(decimals).toString();  
	  if(amount.match(/^\.\d+/)) {return "0"+amount; }
	  else { return amount; }
	}
	
	
};

$(function(){
	$(document).bind('keypress', function (e) {
			if (e.which === 103) {
				$('html').toggleClass('debug');
			}
		});
		Tranceformations.initTOC();
		Tranceformations.initLocationMap();
		Tranceformations.initMobileSidebar();
		Tranceformations.initCollectionFilter();
		Tranceformations.initSharing();
		Tranceformations.initTracking();

		

/*		function adjustStyle(width) {
		    width = parseInt(width);
		    if (width < 1048) {
					$('html').addClass('lo-res');
		    } else {
					$('html').removeClass('lo-res');
				}
		}
		
		//$('#sidebar .content').hide();




		/*adjustStyle($(this).width());
    $(window).resize(function() {
        adjustStyle($(this).width());
    });*/

});
